import type { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@core/ngrx-legacy';
import type { Guest } from '@core/notes-types';

const namespace = 'viewboxGuest';

export const ViewboxGuestActions = createActions(namespace, {
  save: ngrxEvent<{ data: any }>(),
  saveSuccess: ngrxEvent<Guest>(),
  saveFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
